import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 60px;
  padding: 10px 0 15px;
  border-top: 1px solid #69737d;
`;

export const Header = styled.span`
  font-size: 16px;
  font-weight: bold;
`;

export const Content = styled.div`
  width: 100%;
  padding-bottom: 3px;
  display: flex;
  font-size: 14px;
  font-weight: normal;
`;

export const Value = styled.span`
  font-weight: bold;
  margin-left: 5px;
`;
